import { CheckoutBillet, CheckoutCard, CheckoutPix } from './components'

import { CustomerForm as CustomerFormComponent } from 'componentsCheckout'

const CheckoutPayment = ({
  type,
  token,
  order,
  customer,
  setCustomer,
  step,
  setStep,
  loading,
  components,
}) => {
  return (
    <>
      {!loading &&
        (step === 1 ? (
          <CustomerFormComponent
            setStep={setStep}
            setCustomer={setCustomer}
            type={type}
            components={components}
          />
        ) : step === 2 ? (
          <CheckoutBillet
            type={type}
            token={token}
            setStep={setStep}
            setCustomer={setCustomer}
            customer={customer}
            order={order}
          />
        ) : step === 3 ? (
          <CheckoutCard
            type={type}
            token={token}
            setStep={setStep}
            setCustomer={setCustomer}
            customer={customer}
            order={order}
          />
        ) : (
          step === 4 && (
            <CheckoutPix
              type={type}
              token={token}
              setStep={setStep}
              setCustomer={setCustomer}
              customer={customer}
              order={order}
            />
          )
        ))}
    </>
  )
}

export default CheckoutPayment
